/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from "../../../../components/Util/enum";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { formattaPrezzo } from "../../../../components/Util/prezzi";

// Valori dei filtri a chip, come compaiono nella lista.
const TIPO_OPTIONS = [
	{ value: 'SINGOLO', label: 'Singolo' },
	{ value: 'MULTIPLO', label: 'Multiplo' },
];
const STATO_OPTIONS = ['Bozza', 'Attivo', 'Non attivo'];

export const CoursesTable = () => {


	const navigate = useNavigate();
	const [data_json, setDataJson] = useState(null);
	const [sportFilter, setSportFilter] = useState('');
	// Chip a scelta multipla: all'inizio tutti accesi
	const [tipoFilter, setTipoFilter] = useState(TIPO_OPTIONS.map((o) => o.value));
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	// Gli sport sono quelli dei corsi caricati: di solito pochi per struttura.
	const sportOptions = useMemo(
		() => [...new Set((data_json || []).map((row) => row.sportType).filter(Boolean))].sort(),
		[data_json],
	);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) =>
					(!sportFilter || row.sportType === sportFilter) &&
					filtroMultiplo(tipoFilter, TIPO_OPTIONS, row.type === 'CLOSED' ? 'SINGOLO' : 'MULTIPLO') &&
					filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label),
			),
		[data_json, sportFilter, tipoFilter, statoFilter],
	);

	const [loadingShowed, setLoadingShowed] = useState(false);

	// Stato per il popup di selezione tipo corso
	const [courseTypeModal, setCourseTypeModal] = useState(false);
	const [selectedCourseType, setSelectedCourseType] = useState('');
	
	const data_column = [
		{
			Header: 'Nome',
			Footer: 'Nome',
			// La ricerca «nome o maestro» trova anche il maestro: la colonna contiene entrambi, mostra il nome.
			id: 'name',
			accessor: (row) => [row.name, row.coachName].filter(Boolean).join(' '),
			Cell: ({ row }) => row.original.name,
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sportType',
			disableGlobalFilter: true,
		},
		{
			Header: 'Tipo',
			Footer: 'Tipo',
			accessor: 'type',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (value === 'CLOSED' ? 'SINGOLO' : 'MULTIPLO');
			},
			disableFilters: true,
		},
		{
			Header: 'N. Vendite',
			Footer: 'N. Vendite',
			accessor: 'purchasesCount',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return value || 0;
			},
			disableFilters: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
			disableFilters: true,
		},
	];

	function openDetail(row) {
		if(row.status === 'DRAFT') {
			// Controlla il tipo di corso per navigare alla pagina corretta
			if(row.type === 'CLOSED') {
				navigate('/struttura/booking/courseseditclosed/'+row.id);
			} else {
				navigate('/struttura/booking/coursesedit/'+row.id);
			}
		} else {
			// Controlla il tipo di corso per navigare alla pagina di visualizzazione corretta
			if(row.type === 'CLOSED') {
				navigate('/struttura/booking/coursesviewclosed/'+row.id);
			} else {
				navigate('/struttura/booking/coursesview/'+row.id);
			}
		}
	}

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [bookingCourses] = await Promise.all([
                        apiClient.getBookingCourses(token)
                    ]);
					setLoadingShowed(false);

					if(bookingCourses) {
						let data = [];
						bookingCourses.forEach(element => {

							let status = null;
							if(element.status === 'DRAFT') {
								status = {
									"label": "Bozza",
									"class": "text-warning"
								};
							} else if(element.status === 'PURCHASABLE') {
								status = {
									"label": "Attivo",
									"class": "text-success"
								};
							} else if(element.status === 'CANCELLED') {
								status = {
									"label": "Non attivo",
									"class": "text-primary"
								};
							}

							let sportLabel = '';
							sports.forEach(element2 => {
								if(element2.value === element.sportType) {
									sportLabel = element2.label;
								}
							});

							let row = {
								"id": element.id,
								"name": element.name,
								"sportType": sportLabel,
								"startDate": element.startDate,
								"endDate": element.endDate,
								"standard_price": formattaPrezzo(element.standard_price, { conZero: false }),
								"federated_price": formattaPrezzo(element.federated_price, { conZero: false }),
								"type": element.type,
								"status": element.status,
								"status_label": status,
								"purchasesCount": element.purchasesCount,
								"coachName": element.coachName,

							};
							data.push(row);
							
						});
						setDataJson(data);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			{/* Modal per selezione tipo corso */}
			<Modal className="fade" centered show={courseTypeModal} onHide={() => {
				setCourseTypeModal(false);
				setSelectedCourseType('');
			}}>
				<Modal.Header>
					<Modal.Title>Nuovo Corso</Modal.Title>
					<Button
						variant=""
						className="btn-close"
						onClick={() => {
							setCourseTypeModal(false);
							setSelectedCourseType('');
						}}
					>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col>
							<div className="mb-4">
								<label className="form-label">Seleziona il tipo di corso</label>
								<Select
									value={selectedCourseType ? { value: selectedCourseType, label: selectedCourseType === 'chiuso' ? 'Singolo' : 'Multiplo' } : null}
									onChange={(selectedOption) => setSelectedCourseType(selectedOption ? selectedOption.value : '')}
									options={[
										{ value: 'chiuso', label: 'Singolo' },
										{ value: 'aperto', label: 'Multiplo' }
									]}
									placeholder="Seleziona tipo"
									style={{
										lineHeight: "40px",
										color: "#fd7e14",
										paddingLeft: " 15px",
									}}
								/>
							</div>

							<div className="alert alert-info d-flex align-items-start" role="alert" style={{backgroundColor: '#d1ecf1', borderColor: '#bee5eb', color: '#0c5460'}}>
								<div>
									<p className="mb-2"><strong>Singolo:</strong> A questa tipologia di corso dev'essere subito indicato uno Staff Tecnico, un impianto e definire giorni e orari. Una volta creato il corso, verrà generata automaticamente e associata una sola squadra.</p>
									<p className="mb-0"><strong>Multiplo:</strong> A questa tipologia di corso associ la creazione di più squadre in un secondo momento. Per ogni squadra devi indicare Staff Tecnico, impianti e definire giorni e orari.</p>
								</div>
							</div>
							
							{selectedCourseType && (
								<div className="d-flex justify-content-between mt-4">
									<Button 
										variant="light" 
										onClick={() => {
											setCourseTypeModal(false);
											setSelectedCourseType('');
										}}
									>
										ANNULLA
									</Button>
									<Button 
										variant="primary" 
										onClick={() => {
											setCourseTypeModal(false);
											setSelectedCourseType('');
											if (selectedCourseType === 'chiuso') {
												navigate('/struttura/booking/courses/newclosed');
											} else {
												navigate('/struttura/booking/courses/new');
											}
										}}
									>
										CREA CORSO
									</Button>
								</div>
							)}
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<TabellaLista
				pageList={true}
				hasAddMoreAsModal={true}
				labelAddMore={'Nuovo corso'}
				modalCallBack={() => setCourseTypeModal(true)}
				hasSearch={true}
				searchPlaceholder={'Cerca per nome o maestro'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						{sportOptions.length > 1 && <ChipFilter label="Sport" options={sportOptions} value={sportFilter} onChange={setSportFilter} asDropdown />}
						<ChipFilter label="Tipo" options={TIPO_OPTIONS} value={tipoFilter} onChange={setTipoFilter} multiple />
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				sort_by={'name'}
                sort_type={'asc'}
			/>
		</>
	)
}
export default CoursesTable;